import { enqueueSnackbar, DownloadFile } from 'actions';
import {
	ntGetNaspTrackerRequest, ntGetNaspTrackerSuccess, ntGetNaspTrackerFailure,
	ntGetNaspTrackerByIdRequest, ntGetNaspTrackerByIdSuccess, ntGetNaspTrackerByIdFailure,
	ntGetNaspTrackerDropdownsRequest, ntGetNaspTrackerDropdownsSuccess, ntGetNaspTrackerDropdownsFailure,
	ntGetNaspTrackerHistoryRequest, ntGetNaspTrackerHistorySuccess, ntGetNaspTrackerHistoryFailure,
	ntUpdateNaspTrackerRequest, ntUpdateNaspTrackerSuccess, ntUpdateNaspTrackerFailure,
	ntAddNaspTrackerCommentRequest, ntAddNaspTrackerCommentSuccess, ntAddNaspTrackerCommentFailure,
	ntExportNaspTrackerRequest, ntExportNaspTrackerSuccess, ntExportNaspTrackerFailure,
} from './naspTrackerActions';
import {
	NaspTrackerGetRequest,
	NaspTrackerGetByIdRequest,
	NaspTrackerGetDropdownsRequest,
	NaspTrackerGetHistoryRequest,
	NaspTrackerUpdateRequest,
	NaspTrackerAddCommentRequest,
	NaspTrackerExportRequest,
} from '../requests/naspTrackerRequests';

// ─── GET NASP TRACKER — initial load ─────────────────────────────────────────

export const ntGetNaspTracker = (userFlag = 'All') => async (dispatch) => {
	dispatch(ntGetNaspTrackerRequest(userFlag));
	await NaspTrackerGetRequest(userFlag).then((response) => {
		dispatch(ntGetNaspTrackerSuccess(response.data ?? {}, userFlag));
	}).catch((error) => {
		dispatch(ntGetNaspTrackerFailure(error?.message));
	});
};

// ─── GET NASP TRACKER — silent poll ──────────────────────────────────────────

export const ntPollNaspTracker = (userFlag = 'All') => async (dispatch) => {
	await NaspTrackerGetRequest(userFlag).then((response) => {
		dispatch(ntGetNaspTrackerSuccess(response.data ?? {}, userFlag));
	}).catch(() => {});
};

// ─── GET NASP TRACKER BY ID ───────────────────────────────────────────────────

export const ntGetNaspTrackerById = (id) => async (dispatch) => {
	dispatch(ntGetNaspTrackerByIdRequest());
	await NaspTrackerGetByIdRequest(id).then((response) => {
		dispatch(ntGetNaspTrackerByIdSuccess(response.data ?? {}));
	}).catch((error) => {
		dispatch(ntGetNaspTrackerByIdFailure(error?.message));
	});
};

// ─── GET NASP TRACKER DROPDOWNS ───────────────────────────────────────────────

export const ntGetNaspTrackerDropdowns = () => async (dispatch) => {
	dispatch(ntGetNaspTrackerDropdownsRequest());
	await NaspTrackerGetDropdownsRequest().then((response) => {
		dispatch(ntGetNaspTrackerDropdownsSuccess(response.data ?? {}));
	}).catch((error) => {
		dispatch(ntGetNaspTrackerDropdownsFailure(error?.message));
	});
};

// ─── GET NASP TRACKER HISTORY — initial load ──────────────────────────────────

export const ntGetNaspTrackerHistory = () => async (dispatch) => {
	dispatch(ntGetNaspTrackerHistoryRequest());
	await NaspTrackerGetHistoryRequest().then((response) => {
		dispatch(ntGetNaspTrackerHistorySuccess(response.data ?? []));
	}).catch((error) => {
		dispatch(ntGetNaspTrackerHistoryFailure(error?.message));
	});
};

// ─── GET NASP TRACKER HISTORY — silent poll ───────────────────────────────────

export const ntPollNaspTrackerHistory = () => async (dispatch) => {
	await NaspTrackerGetHistoryRequest().then((response) => {
		dispatch(ntGetNaspTrackerHistorySuccess(response.data ?? []));
	}).catch(() => {});
};

// ─── UPDATE NASP TRACKER ──────────────────────────────────────────────────────

export const ntUpdateNaspTracker = (dto, onSuccess) => async (dispatch) => {
	dispatch(ntUpdateNaspTrackerRequest());

	const payload = {
		...dto,
		daysOos:    dto.daysOos   !== '' && dto.daysOos   != null ? parseInt(dto.daysOos, 10) : 0,
		dateOos:    dto.dateOos    || '0001-01-01',
		eta:        dto.eta        || '0001-01-01',
		insertDate: dto.insertDate || '0001-01-01',
	};

	await NaspTrackerUpdateRequest(payload).then(() => {
		dispatch(ntUpdateNaspTrackerSuccess());
		if (onSuccess) onSuccess();
	}).catch((error) => {
		dispatch(ntUpdateNaspTrackerFailure(error?.message));
	});
};

// ─── ADD NASP TRACKER COMMENT ─────────────────────────────────────────────────

export const ntAddNaspTrackerComment = (dto, onSuccess) => async (dispatch) => {
	dispatch(ntAddNaspTrackerCommentRequest());
	await NaspTrackerAddCommentRequest(dto).then(() => {
		dispatch(ntAddNaspTrackerCommentSuccess());
		dispatch(ntGetNaspTrackerById(dto.tableId));
		if (onSuccess) onSuccess();
	}).catch((error) => {
		dispatch(ntAddNaspTrackerCommentFailure(error?.message));
	});
};

// ─── EXPORT NASP TRACKER ──────────────────────────────────────────────────────

export const ntExportNaspTracker = (userId) => async (dispatch) => {
	dispatch(ntExportNaspTrackerRequest());
	await NaspTrackerExportRequest(userId).then((response) => {
		dispatch(DownloadFile(response.data));
		dispatch(ntExportNaspTrackerSuccess());
	}).catch((error) => {
		dispatch(ntExportNaspTrackerFailure(error?.message));
		dispatch(enqueueSnackbar({ message: error?.message ?? 'Export failed.', options: { variant: 'error' } }));
	});
};